import { DestinationContainer } from "../../containers";
import "./style.scss";

function DestinationDetail() {
  return (
    <div id="destinationPage">
      <DestinationContainer />
    </div>
  );
}
export default DestinationDetail;
